import { axios, API } from './config';

export const customPackingItemsAPI = {
  list: async (prefix = null, limit = 200) => {
    const params = { limit };
    if (prefix) params.prefix = prefix;
    const response = await axios.get(`${API}/custom-packing-items`, { params });
    return response.data;
  },

  upsert: async ({ name, quantity = 1 }) => {
    const response = await axios.post(`${API}/custom-packing-items/upsert`, { name, quantity });
    return response.data;
  },

  remove: async (id) => {
    const response = await axios.delete(`${API}/custom-packing-items/${id}`);
    return response.data;
  },
};
